import { computed, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';

import { filter, map, take } from 'rxjs';

import { StoreRequest } from '@bn/store-kit/v1';

import { AppRoutes } from '../../core/enums';

import { hasContractDates } from './customer-contract.util';
import { PartnerCustomerStore } from './stores';

/** Blocks the Contract tab for customers without contract dates (deep links included). */
export const customerContractGuard: CanActivateFn = (route) => {
  const store = inject(PartnerCustomerStore);
  const router = inject(Router);
  const customerId = route.parent?.paramMap.get('customerId') ?? '';

  const listSettled = computed(() => store.isFinished(StoreRequest.List)() || store.isError(StoreRequest.List)());

  return toObservable(listSettled).pipe(
    filter(Boolean),
    take(1),
    map(() => {
      const customer = store.customers().find((item) => item.CustomerUserId === customerId);

      return hasContractDates(customer) ? true : router.createUrlTree(['/', AppRoutes.Overview, customerId]);
    }),
  );
};
